const ATTACHABLE_TREE_ID_PREFIX = 'attachable-';
export function buildAttachableTreeId(attachableType, attachableId) {
    return `${ATTACHABLE_TREE_ID_PREFIX}${attachableType}-${attachableId}`;
}
export function parseAttachableTreeId(itemId) {
    if (itemId == null)
        return null;
    const itemIdString = String(itemId);
    if (!itemIdString.startsWith(ATTACHABLE_TREE_ID_PREFIX))
        return null;
    const match = itemIdString.match(/^attachable-(.+)-(\d+)$/);
    if (!match)
        return null;
    return {
        attachableType: match[1],
        attachableId: Number(match[2])
    };
}
